export const APPROVED = 'APPROVED';
export const PENDING = 'PENDING';
export const REJECTED = 'REJECTED';
export const EXPIRED = 'EXPIRED';
